export const TooltipMessage = {
  requestUserAccessData: "Request user access data from Application support team",
  preview: "Click to preview the delegation",
  startReview: {
    enabled: "Click to start review",
    disabled: {
      moreThanWeek: "The User Access data should be latest (within a week) to start a review",
      noReviewee: "No reviewee to start review",
      noUserAccessDataDump: "No User Access data",
      inReviewVerificationPending: "The review is still in verification pending"
    },
  },
  reasonNotEntered: "The button will be enabled only after the selection of a reason and comment.",
  reasonNotModified: "The button will be enabled only if there are changes made to the reason and comment.",
  commentNotModified: "The button will be enabled only if there are changes made to the comment.",
  closeReview: "Click to close review",
  cancelReview: "Click to cancel review",
  assign: "Click to assign",
  reassign: {
    enabled: "Click to reassign",
    disabled: "Cannot reassign",
  },
  sendReminder: "Click to send reminder",
  downloadCSVReport: "Download in csv format",
  appInfoIcon(applicationName) {
    return `${applicationName} App-Info`;
  },
  accessTypeIcon(applicationName) {
    return `${applicationName} Access Types`;
  },
  copyAllEmails: {
    GAA: "Click to copy all the emails of Global access approvers",
    AO: "Click to copy all the emails of Access owners",
    userGroups: {
      users: (userGroupRepresentationName, userRoleName) =>
        `Click to copy all the emails of ${userGroupRepresentationName} ${userRoleName}`,
    },
  },
  viewKeyConditionMembers: "View members",
  editKeyCondition: "Edit key condition",
  deleteKeyCondition: "Delete key condition",
  editIndividualInclusionMemberDetails: "Edit individual inclusion member details",
  editSpecialMemberDetails: "Edit special member details",
  deleteIndividualInclusionMember: "Delete individual inclusion member",
  deleteSpecialMember: "Delete special member",
  removeExcludeMember: "Remove excluded member",
  saveForLater:{
    disabled:{
      invalidDecision:"Currently Disabled: Some of the entered decisions requires comments! Please fill them to save the decisions",
      noEditedDecisions:"Currently Disabled: No pending actions available to be saved"
    }
  }
};
